// extracted by css-extract-rspack-plugin
export default {"JoinColumnPicker":"wX4lc","JoinCellItem":"PcKTA","isReadOnly":"YzNBR","hasColumnStyle":"hjVOD","isOpen":"TSGNa","noColumnStyle":"SL03f"};